import { Controller } from "@hotwired/stimulus"

import { createChart } from "../src/chart"

export default class extends Controller {
  static values = {
    currency: String,
    data: Array,
    kind: { type: String, default: "line" },
    labels: Array,
    title: { type: String, default: "Chart" },
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.chart = createChart(this.element, {
      currency: this.hasCurrencyValue ? this.currencyValue : null,
      data: this.dataValue,
      kind: this.kindValue,
      labels: this.labelsValue,
      title: this.titleValue,
    })
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
